/**
 * kioskReadOnly.js — global mixin
 *
 * Adds $isKioskSession to every Vue component so templates can do:
 *   v-if="!$isKioskSession"
 *
 * Registered globally in main.js via Vue.mixin(kioskReadOnly).
 */
import auth from "@/helpers/auth";

export default {
  computed: {
    $isKioskSession() {
      return auth.isReadOnly();
    },
  },
};
